import store from "@/store";
import router from "@/core/router";
import {grantAccessToContextApp} from "@/services/AuthService";

export default {
    beforeRouteEnter(to) {
        if (!to.query.code) {
            return this.$router.push('/');
        }

        return store.dispatch('Auth/loginByCode', to.query.code)
            .then(() => {

                if (! store.state.context.app) {
                    router.push({name: 'Dashboard'})
                }

                store.dispatch('Auth/fetchApplications')
                    .then(() => {
                        return grantAccessToContextApp(router, () => router.push({name: 'Dashboard'}));
                    })
                    .catch(() => router.push({name: 'Dashboard'}))
            });
    },
}